import { useSnapshot } from 'valtio/react';

import { requiringActionManager } from '@paid-ui/models/requiring-action';
import { useGetRequiringActions } from '@paid-ui/queries/requiring-actions';
import {
  isAcknowledgedRequiringAction,
  isVisibleRequiringAction,
} from '@paid-ui/utils/requiring-action';

export const CountIndicator: React.FC = () => {
  const { requiringActions } = useSnapshot(requiringActionManager);

  useGetRequiringActions();

  const count = requiringActions
    .filter((data) => !isAcknowledgedRequiringAction(data))
    .filter(isVisibleRequiringAction).length;

  if (!count) {
    return null;
  }

  return (
    <span className="absolute -right-1 top-0 inline-flex min-h-[16px] min-w-[15px] shrink-0 animate-badge-pulse items-center justify-center rounded bg-pink px-1 text-xs font-medium text-white shadow-sm md:right-4 md:top-1">
      {count > 99 ? '99+' : count}
    </span>
  );
};
